import React, { Component } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import ReferenciaRelatorio from './components/referencia'
import { RelatorioContext } from '../../contexts/Relatorio'
import ResumoRelatorio from './components/resumo'
import ButtonsForm from '../../components/ButtonsForm'
import GraficoRelatorio from './components/grafico'
import Select from '../../components/Select'
import { Link, Redirect } from 'react-router-dom'
import ReactLoading from 'react-loading'
import helper from '../../utils/helper'
import domToImage from 'dom-to-image'
import pdfMake from 'pdfmake'
import auth from '../../utils/auth'
import cfg from '../../utils/config'
import axios from 'axios'
import ChartItem from './components/ChartItem'
import GeneratedChart from './components/GeneratedChart'
import GenericInputDate from '../../components/GenericInputDate'
import { formatValueLabel } from '../../utils/normalizeDateHelpers'

pdfMake.fonts = {
    Roboto: {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    }
}

class Form extends Component {
    static contextType = RelatorioContext

    userInfo = auth.getUserInfo()
    configMe = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

    state = {
        detalhesDefault: { data: {}, agrupar: "", descricao: "", cliente: "" },
        validacao_formulario: { data: true, descricao: true, agrupar: true },
        carregandoDados: false,
        relatorioGerado: false,
        charts: [],
        originalChartsList: [],
        chartsListSelected: [],
        optionsCliente: [],
        redirect: false,
        cooldown: false,
        exportCooldown: false,
        relatorioErro: false,
        cliente: false,
        tabIndex: 0,
        disabledCliente: false,
        periodoValido: true,
        mensagemAviso: "",
        isReordering: false,
    }

    componentWillMount() {
        this.context.set({ getData: this.getData })
    }

    componentDidMount() {
        this.setState({ cliente: auth.getUserInfo().tipo === "cliente" })

        if (this.userInfo.tipo === "cliente") {
            let optionsCliente = [{ value: this.userInfo.cliente, label: this.userInfo.nome }]

            this.setState({ optionsCliente })

            if (this.props.match.params.id) {
                this.context.set({ relatorioId: this.props.match.params.id, clientes: optionsCliente })

                this.getData()
            }
        } else {

            this.getClients().then(() => {
                if (this.props.match.params.id) {
                    this.context.set({ relatorioId: this.props.match.params.id })

                    this.getData()
                }
            })
        }
    }

    getClients = async () => {
        await axios.get(cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/cliente/', this.configMe)
            .then(cliente => {
                let optionsCliente = []
                optionsCliente.push({ label: 'Nenhum', value: null })

                if (cliente.data?.results.length > 0) {
                    cliente.data?.results?.forEach((c) => {
                        optionsCliente.push({ "value": c.id, "label": c.nome_fantasia })
                    })
                }

                this.context.set({ clientes: optionsCliente })
                this.setState({ optionsCliente })
            })
    }

    getReferencias = () => {
        axios.get(cfg.base_api_url + cfg.api_v2 + `/${this.userInfo.empresa}/relatorio/${this.props.match.params.id}/referencia/?limit=100`, this.configMe)
            .then(res => {
                let referencias = []
                const { resource } = this.context

                if (res.data) {
                    referencias = res.data?.results ?? []
                    referencias.map(ref => {
                        ref['tipo_da_referencia'] = resource.referenciaOptions.find(r => r.value === ref['tipo_da_referencia'])
                        ref['automacao'] = resource.automacaoOptions.find(a => a.value === ref['automacao'])
                    })
                }

                this.context.set({ referencias })
            })
    }

    getResumos = () => {
        axios.get(cfg.base_api_url + cfg.api_v2 + `/${this.userInfo.empresa}/relatorio/${this.props.match.params.id}/resumo`, this.configMe)
            .then(res => {
                const { resource } = this.context
                let resumos = []

                if (res.data) {
                    resumos = res.data?.results ?? []
                    resumos.map(resumo => {
                        resumo['icone'] = resource.resumoIconOptions.find(icon => icon.value === resumo['icone'])
                        if (resumo?.['resumo_pre_definido']) {
                            resumo['tipo'] = resource.tiposResumo.find(tipo => tipo.value === resumo['resumo_pre_definido'])
                        }
                    })
                }

                this.context.set({ resumos })
            })
    }

    getData = (updateDefault = true) => {
        this.setState({ relatorioGerado: false })

        axios({
            method: 'GET',
            url: cfg.base_api_url + cfg.api_v2 + `/${this.userInfo.empresa}/relatorio/${this.props.match.params.id}`,
            ...this.configMe
        }).then(res => {
            let { detalhesDefault, optionsCliente } = this.state
            const data = res.data

            if (updateDefault) {
                detalhesDefault['descricao'] = data.descricao
                detalhesDefault['agrupar'] = { label: 'Dia', value: 'dia' }
                detalhesDefault['cliente'] = optionsCliente?.find(c => c.value == res.data?.cliente)

                this.setState({ detalhesDefault, relatorioGerado: false, disabledCliente: true })
            }

            this.getReferencias()
            this.getResumos()
        }).catch(error => {
            console.error(error)
            this.setState({ relatorioErro: true })
        })

        axios.get(cfg.base_api_url + cfg.api_v2 + `/${this.userInfo.empresa}/relatorio/${this.props.match.params.id}/grafico/?limit=100`, this.configMe)
            .then(res => {
                let charts = res.data?.results || []

                const tipos = {
                    linha: { label: 'Linha', value: 'linha' },
                    barra: { label: 'Barra', value: 'barra' }
                }

                const visualizacoes = {
                    med: { label: 'Média do período', value: 'med' },
                    tudo: { label: 'Todo o período', value: 'tudo' },
                    min_max: { label: 'Mínima e Máxima', value: 'min_max' },
                }

                const calcularComo = {
                    padrao: { label: 'Padrão', value: 'padrao' },
                    volume: { label: 'Volume', value: 'volume' },
                    horimetro: { label: 'Horímetro', value: 'horimetro' },
                }

                charts?.forEach(chart => {
                    chart['tipo_grafico'] = tipos[chart['tipo_grafico']]
                    chart['visualizacao'] = visualizacoes[chart['visualizacao']]
                    chart['calcular_como'] = calcularComo[chart['calcular_como']]
                })

                this.context.set({ charts })
            })
    }

    saveAction = () => {
        let { detalhesDefault } = this.state
        let not_validate = false
        let validate_form = this.state.validacao_formulario
        let except = ['data', 'agrupar']

        for (let key in validate_form) {
            if (!detalhesDefault[key] && !except.includes(key)) {
                validate_form[key] = false
                not_validate = true
            } else
                validate_form[key] = true
        }

        this.setState({ validacao_formulario: validate_form, carregandoDados: false })

        if (not_validate) {
            window.scrollTo(0, 50)
            return
        }

        this.setState({ cooldown: true })

        let verb = 'POST'
        let url = cfg.base_api_url + cfg.api_v2 + `/${this.userInfo.empresa}/relatorio/`
        if (this.props.match.params.id) {
            verb = 'PATCH'
            url = cfg.base_api_url + cfg.api_v2 + `/${this.userInfo.empresa}/relatorio/${this.props.match.params.id}/`
        }

        const bodyFormData = {
            descricao: detalhesDefault.descricao
        }

        if (this.userInfo?.tipo == "cliente" && this.userInfo?.cliente) {
            bodyFormData['cliente_id'] = this.userInfo?.cliente
        } else {
            bodyFormData['cliente_id'] = detalhesDefault.cliente ? detalhesDefault.cliente?.value : null
        }

        axios({ method: verb, url: url, data: bodyFormData, ...this.configMe }).then(res => {
            helper.dispatchEvent("showAviso", {
                message: 'Relatorio salvo com sucesso',
                callback: () => this.setState({ redirect: true, path: "/relatorio-customizado" })
            })
        })

        setTimeout(() => this.setState({ cooldown: false }), 1000)
    }

    getResource = () => {
        let userInfo = auth.getUserInfo()
        let requestArray = []

        requestArray.push(axios.get(cfg.base_api_url + cfg.api_v2 + `/${userInfo.empresa}/automacao/?limit=100`, this.configMe))

        axios.all(requestArray).then(axios.spread((automacoes) => {
            let automacaoOptions = []
            let resource = this.context.resource

            if (automacoes.data) {
                automacoes?.data?.results?.forEach(resource => {
                    automacaoOptions.push({
                        label: resource.descricao,
                        value: resource.id,
                        condicao: resource.condicao
                    })
                })
            }

            resource['automacaoOptions'] = automacaoOptions
            this.context.set({ resource })
        }))
    }

    buscarDadosRelatorio = () => {
        this.setState({ carregandoDados: true, relatorioGerado: false, relatorioErro: false })
        let { charts } = this.context
        let { detalhesDefault } = this.state
        let notValid = false
        let valiate_form = this.state.validacao_formulario
        const except = ['descricao']

        for (let key in detalhesDefault) {
            if (!detalhesDefault[key] && !except.includes(key)) {
                valiate_form[key] = false
                notValid = true
            } else {
                valiate_form[key] = true
            }
        }

        if (notValid) {
            this.setState({ validacao_formulario: valiate_form, carregandoDados: false })
            return
        }

        const primeiro_periodo = detalhesDefault.data.firstPeriod
        const segundo_periodo = detalhesDefault.data.secondPeriod
        const comparar_periodos = detalhesDefault.data.compare
        const agrupar_por = detalhesDefault.agrupar?.value
    
        const bodyFormData = {
            relatorio_id: this.props.match.params.id,
            agrupar_por: agrupar_por,
            primeiro_periodo: primeiro_periodo,
            gerar_comparativo: comparar_periodos
        }

        if(comparar_periodos) {
            bodyFormData["segundo_periodo"] = segundo_periodo
        }

        axios({
            method: "POST",
            url: cfg.base_api_url + cfg.api_v2 + `/${this.userInfo.empresa}/relatorio/customizado/comparativo/`,
            data: bodyFormData,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        })
       .then(res => {
            this.setState({ carregandoDados: false })

            let graficos = res.data.graficos
            let groupBy = res.data.agrupar_por

            graficos = graficos.map((grafico) => {
                const series = []
                const dates = grafico.datas

                grafico.dados.forEach((item) => {
                    const referencia = item.tipo === "referencia"

                    const serie = {
                        name: item.parametro,
                        data: item.data,
                        type: grafico.tipo_grafico === "barra" ? "bar" : "line",
                        itemStyle: { color: item.cor_linha || grafico.cor_linha, opacity: referencia ? 0.85 : 1 },
                        lineStyle: { width: referencia ? 2 : 3, opacity: referencia ? 0.85 : 1 },
                        labelLayout: { hideOverlap: true },
                        showSymbol: !referencia,
                        visualizacao: grafico.visualizacao,
                        tipo_grafico: grafico.tipo_grafico,
                        calcular_como: grafico.calcular_como,
                        label: {
                            show: true,
                            position: 'top',
                            fontWeight: 'bold',
                            formatter: (params) =>  {
                                let value = null

                                if(Array.isArray(params.value)) {
                                    value = params.value[1]
                                } else {
                                    value = params.value
                                }

                                if(grafico.calcular_como === "horimetro") {
                                    value = helper.decimalToTime(value)
                                } 

                                return value
                            }
                        },
                    }

                    if(referencia) {
                        const { descricao, cor_linha, tipo_da_referencia } = item.referencia

                        serie.name = descricao
                        serie.type = "line"
                        serie.lineStyle.type = "dashed"
                        serie.itemStyle.color = cor_linha
                        serie.markPoint = {
                            data: [
                                {
                                    coord: [0, Array.isArray(item.data[0]) ? item.data[0][1] : item.data[0]],
                                    symbol: "circle",
                                    symbolSize: 10,
                                    label: {
                                        show: true,
                                        position: 'top',
                                        fontWeight: 'bold',
                                        formatter: (params) => Number(params.data.coord[1]).toLocaleString("pt-BR")
                                    }
                                },
                                {
                                    coord: [(item.data.length - 1), Array.isArray(item.data[item.data.length - 1]) ? item.data[item.data.length - 1][1] : item.data[item.data.length - 1]],
                                    symbol: "circle",
                                    symbolSize: 10,
                                    label: { show: true, position: "top", fontWeight: "bold" }
                                },
                            ]
                        }

                        if(tipo_da_referencia === "dinamico"){
                            serie.showSymbol = true
                        }

                    } else if(grafico.tipo_grafico === "barra" && grafico.tem_dinamico_periodo_todo) {
                        serie.type = "line"
                        serie.areaStyle = true
                    } 
                    
                    if(item.tipo === "principal" && item.periodo === "segundo") {
                        serie.itemStyle.color = "#3ecf8e"
                    }

                    series.push(serie)
                })

                return {
                    comparacao: grafico.comparacao,
                    comparar_periodos: res.data.gerar_comparativo,
                    descricao: grafico.descricao,
                    resumos: grafico.resumos,
                    referencias: grafico.referencias_detalhes,
                    xAxis: dates,
                    series: series,
                    unidade: "",
                    sinal: "",
                    groupBy
                }
            })

            this.setState({ charts: graficos, carregandoDados: false, relatorioGerado: true })
        })
        .catch(err => {
            console.error(err)
            this.setState({ carregandoDados: false, relatorioGerado: false, relatorioErro: true })
        })
    }

    gerarGrafico = () => {
        const { charts, carregandoDados } = this.state

        if (carregandoDados) return []

        return charts.map(chart => {
            const { series } = chart

            return {
                id: chart.id,
                descricao: chart.descricao,
                series,
                xAxis: chart.xAxis,
                legend: series?.map(s => s.name) ?? [],
                resumos: chart.resumos,
                referencias: chart.referencias,
                comparacao: chart.comparacao,
                comparar_periodos: chart.comparar_periodos,
                groupBy: chart.groupBy
            }
        })
    }

    handleChangeRelatorio = (value, field) => {
        const { detalhesDefault } = this.state

        if (field === 'data') {
            if (value.compare) {
                detalhesDefault[field].firstPeriod = {
                    data_inicio: value.firstPeriod.startDate,
                    data_fim: value.firstPeriod.endDate
                }
                detalhesDefault[field].secondPeriod = {
                    data_inicio: value.secondPeriod.startDate,
                    data_fim: value.secondPeriod.endDate
                }
                detalhesDefault[field].compare = true
            } else {
                detalhesDefault[field].firstPeriod = {
                    data_inicio: value.startDate,
                    data_fim: value.endDate
                }
                detalhesDefault[field].compare = false
            }
        } else {
            detalhesDefault[field] = value
        }

        this.setState({ detalhesDefault }, () => {
            if (field === 'agrupar' || field === 'data') {
                this.validatePeriod()
            }
        })
    }

    validatePeriod = () => {
        const { detalhesDefault } = this.state
        const comparar_periodos = detalhesDefault.data.compare

        const primeiro_periodo_inicio = detalhesDefault?.data?.firstPeriod?.data_inicio * 1000
        const primeiro_periodo_fim = detalhesDefault?.data?.firstPeriod?.data_fim * 1000
        const primeiro_periodo_dias = Math.ceil((primeiro_periodo_fim - primeiro_periodo_inicio) / (1000 * 60 * 60 * 24))

        const segundo_periodo_inicio = detalhesDefault?.data?.secondPeriod?.data_inicio * 1000
        const segundo_periodo_fim = detalhesDefault?.data?.secondPeriod?.data_fim * 1000
        const segundo_periodo_dias = Math.ceil((segundo_periodo_fim - segundo_periodo_inicio) / (1000 * 60 * 60 * 24))

        let mensagemAviso = ""
        let periodoValido = true

        if(comparar_periodos) {
            if(primeiro_periodo_dias > segundo_periodo_dias || primeiro_periodo_dias < segundo_periodo_dias) {
                mensagemAviso = "Os periodos comparativos devem ter a mesma quantidade de dias."
                periodoValido = false
                this.setState({ mensagemAviso, periodoValido })
                return
            }
        }

        const condition = (value) => comparar_periodos ? primeiro_periodo_dias > value || segundo_periodo_dias > value : primeiro_periodo_dias > value

        switch (detalhesDefault.agrupar?.value) {
            case 'hora':
                if (condition(1)) {
                    mensagemAviso = "O período selecionado é muito grande para o agrupamento por hora. Limite de 1 dia."
                    periodoValido = false
                }
                break
            case 'dia':
                if (condition(31)) {
                    mensagemAviso = "O período selecionado é muito grande para o agrupamento por dia. Limite de 31 dias."
                    periodoValido = false
                }
                break
            case 'mes':
                if (condition(366)) {
                    mensagemAviso = "O período selecionado é muito grande para o agrupamento por mês. Limite de 12 meses."
                    periodoValido = false
                }
                break
            default:
                break
        }
        this.setState({ mensagemAviso, periodoValido })
    }

    hideRef = () => {
        let referencias = document.querySelectorAll('.hdv-chart-refs')
        let icones = document.querySelectorAll('.hdv-resumo i')
        referencias.forEach(ref => ref.hidden = true)
        icones.forEach(icone => icone.classList.add('hide-icon'))

        setTimeout(() => {
            referencias.forEach(ref => ref.hidden = false)
            icones.forEach(icone => icone.classList.remove('hide-icon'))
        }, 1000)
    }

    exportarPDF = async () => {
        const { charts } = this.context
        const { detalhesDefault } = this.state
        let canvas = document.querySelectorAll('.generated-chart') ?? []
        let infoEmpresa
        let graficos = []
        this.setState({ exportCooldown: true })
        this.hideRef()

        for(const c of canvas) {
            let data
            const item = charts.find(chart => `chart-id-${chart.id}` === c.id)
            data = await domToImage.toPng(c)

            graficos.push({ ...item, dom: c, img: data })
        }

        let data_formatada = ""

        data_formatada = formatValueLabel({
            startDate: detalhesDefault.data.firstPeriod.data_inicio,
            endDate: detalhesDefault.data.firstPeriod.data_fim
        })

        if(detalhesDefault.data.compare) {
            const segunda_data_formatada = formatValueLabel({
                startDate: detalhesDefault.data.secondPeriod.data_inicio,
                endDate: detalhesDefault.data.secondPeriod.data_fim
            })

            data_formatada += " vs " + segunda_data_formatada
        }

        await axios.get(cfg.base_api_url + cfg.api_v2 + `/${this.userInfo.empresa}/configuracao-sistema`, this.configMe)
            .then(res => {
                infoEmpresa = res.data?.results?.[0]
                if (detalhesDefault.cliente?.label && infoEmpresa) {
                    infoEmpresa.descricao = detalhesDefault.descricao
                    infoEmpresa.cliente = detalhesDefault.cliente.label
                    infoEmpresa.data = data_formatada
                }
            })

        const dadosRelatorio = []
        if (infoEmpresa?.descricao) {
            dadosRelatorio.push(`Relatório: ${infoEmpresa?.descricao}`)
        }
        if (infoEmpresa?.cliente) {
            dadosRelatorio.push(`\nCliente: ${infoEmpresa?.cliente}`)
        }
        if (infoEmpresa?.data) {
            dadosRelatorio.push(`\nPeríodo: ${infoEmpresa?.data}`)
        }

        const dadosEmpresa = []
        if (infoEmpresa?.email_contato) {
            dadosEmpresa.push(`Contato: ${infoEmpresa?.email_contato}`)
        }
        if (infoEmpresa?.telefone) {
            dadosEmpresa.push(` Telefone: ${infoEmpresa?.telefone}`)
        }
        if (infoEmpresa?.endereco) {
            dadosEmpresa.push(`\nEndereço: ${infoEmpresa.endereco}`)
        }

        const pdfOptions = {
            content: [
                {
                    table: {
                        widths: ['*', 120],
                        body: [[
                            {
                                text: dadosRelatorio,
                                border: [false, false, false, true],
                            },
                            { image: 'logo', style: 'logo', width: 80, border: [false, false, false, true] }
                        ]]
                    },
                },
                {
                    table: {
                        body: [[
                            {
                                text: dadosEmpresa,
                                border: [false, false, false, false],
                            },
                        ]]
                    },
                }
            ],
            images: { 'logo': document.querySelector('div.hdv-logomarca img')?.src, },
            styles: {
                logo: { margin: [40, -18, 70, 0] },
                info: { margin: [5, 8], fontSize: '11', color: '#444444' }
            }
        }

        graficos?.forEach(async (grafico, index) => {
            pdfOptions.images['chart_' + index] = grafico.img
            pdfOptions.content.push({
                image: 'chart_' + index,
                margin: [0, 20],
                width: 516,
            })
        })

        pdfMake.createPdf(pdfOptions).open({}, window.open('', '_blank'))
        this.setState({ exportCooldown: false })
    }

    resetarGrafico = () => {
        this.context.set({
            graficoModal: {
                ativo: true, novo: true,
                grafico: {
                    campo_customizado: '', descricao: '', tipo_grafico: '', campo_referencia: '', data: [],
                    cor_linha: '#4287f5', label: true, visualizacao: { label: 'Média do período', value: 'med' },
                    calcular_como: { label: 'Padrão', value: 'padrao' }, configuracoes_extras: {}
                },
            },
        })
    }

    editChart = (chart) => {
        let { graficoModal } = this.context
        if (graficoModal.grafico) {
            graficoModal.grafico['valido'] = true
        }

        this.context.set({
            graficoModal: { ativo: true, grafico: chart },
            selected: { cliente: '', monitorado: '', campo: '' }
        })
    }

    selectChart = (chart) => {
        const { chartsListSelected } = this.state
        if (chartsListSelected.includes(chart)) {
            this.setState({ chartsListSelected: [] });
            return
        }

        this.setState(
            { chartsListSelected: [...chartsListSelected, chart] },
            () => {
                if(this.state.chartsListSelected.length < 2) return

                if(!this.state.originalChartsList.length) {
                    this.setState({ originalChartsList: this.context.charts });
                }

                const from = this.state.chartsListSelected[0];
                const to = this.state.chartsListSelected[1];
                this.context.reorderCharts(from, to);

                this.setState({ chartsListSelected: [] });
            }
        );
    }

    toggleEditOrdenation = () => {
        if(this.state.isReordering) {
            this.saveReorder();
        }
        this.setState((state) => ({
            chartsListSelected: [],
            isReordering: !state.isReordering,
        }));
    };

    saveReorder = () => {
        const originalCharts = this.state.originalChartsList;
        const charts = this.context.charts;
        const hasOrderChanged = originalCharts.some(
            (chart, index) => chart.id !== charts[index].id
        );

        if (originalCharts.length && hasOrderChanged) {
            const chartsId = charts.map((chart) => chart.id)
            const verb = "POST"
            const url = cfg.base_api_url + cfg.api_v2 + `/${this.userInfo.empresa}/relatorio/customizado/graficos/ordenar/`

            axios({ method: verb, url: url, data: chartsId, ...this.configMe }).then(res => {
                this.setState({ originalChartsList: [] });
                helper.dispatchEvent("showAviso", {
                    message: 'Gráficos ordenados com sucesso',
                    callback: () => this.getData()
                });
            })

        }
    }

    render() {
        const { relatorioGerado, detalhesDefault, tabIndex, disabledCliente, periodoValido, mensagemAviso, isReordering, chartsListSelected } = this.state
        const { charts } = this.context
        const generatedCharts = this.gerarGrafico();

        if (this.state.redirect)
            return <Redirect to="/relatorio-customizado" />

        return (
            <>
                <ResumoRelatorio detalhes={detalhesDefault} />

                <ReferenciaRelatorio detalhes={detalhesDefault} />

                <GraficoRelatorio detalhes={detalhesDefault} />

                <div>
                    <div className="hdv-default-header mx-3">
                        <span className="screen-menu-desc">
                            <h4>Relatório Customizado</h4>
                            <div className="gray-background">
                                <i className="fa fa-file-alt fa-2x"></i>
                            </div>
                        </span>
                        <ReactLoading
                            id="loading"
                            className={this.state.carregandoDados ? "hdv-report-loading" : "hdv-noshow-item"}
                            type="cylon"
                            color="var(--background-menu)"
                            height={20}
                            width={50}
                        />
                    </div>

                    <Tabs
                        selectedIndex={this.state.tabIndex}
                        onSelect={(tabIndex) => this.setState({ tabIndex })}>
                        <TabList>
                            <Tab>Configuração</Tab>
                            <Tab>Gráficos</Tab>
                        </TabList>

                        <TabPanel>
                            <details open={true} className='custom-summary'>
                                <summary>Filtros</summary>

                                <div style={{ padding: "20px" }} className="hdv-form-default">
                                    <div className="row">
                                        <div className={this.userInfo?.tipo != "cliente" ? "col-md-8 " : "col-md-12"}>
                                            <label className="required mt-0">Descrição</label>
                                            <input
                                                type="text"
                                                onChange={(e) => this.handleChangeRelatorio(e.target.value, 'descricao')}
                                                value={detalhesDefault.descricao}
                                                /*disabled={this.state.cliente}*/
                                            />
                                            <span className={(this.state.validacao_formulario.descricao === false) ? "hdv-required-field" : "hdv-required-field hdv-noshow-item"}>
                                                Campo Obrigatório
                                            </span>
                                        </div>

                                        {this.userInfo?.tipo != "cliente"
                                            ?
                                            <div className="col-md-4">
                                                <label className="required mt-0">Cliente</label>
                                                <Select
                                                    disabled={disabledCliente}
                                                    value={detalhesDefault.cliente}
                                                    onChange={(e) => this.handleChangeRelatorio(e, 'cliente')}
                                                    options={this.state.optionsCliente}
                                                />
                                            </div>
                                            :
                                            null
                                        }
                                    </div>

                                    <div className='row'>
                                        <div className="col-md-6">
                                            <label className="required">Periodo</label>
                                            <GenericInputDate
                                                onChange={(value) => this.handleChangeRelatorio(value, "data")}
                                                isCompare
                                                haveInitialValue
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="required">Agrupar por</label>
                                            <Select
                                                value={detalhesDefault.agrupar}
                                                onChange={(e) => this.handleChangeRelatorio(e, "agrupar")}
                                                options={this.context.resource.agruparOptions}
                                            />
                                        </div>
                                        {!periodoValido ? <span id='validacao-periodo'>{mensagemAviso}</span> : null}
                                    </div>
                                </div>
                            </details>
                        </TabPanel>
                        <TabPanel>
                            <button
                                style={{ position: "relative", width: "100%", height: "50px", background: "var(--fonte_titulo_abas)" }}
                                className="hdv-btn-forms hdv-btn-green"
                                onClick={() => {
                                    this.resetarGrafico()
                                    this.getResource()
                                }}>
                                Novo Gráfico
                            </button>

                            {this.context.charts.length ? (
                                <>
                                    {this.context.charts.length > 1 && (
                                        <summary
                                            className={
                                                isReordering
                                                    ? "custom-report-reorder-popover-button gray-background custom-report-reorder-popover-button-active"
                                                    : "custom-report-reorder-popover-button gray-background"
                                            }
                                            onClick={this.toggleEditOrdenation}
                                        >
                                            <i className="las la-exchange-alt la-2x gray-primary" style={{transform: "rotate(90deg)"}}></i>
                                            <span className="custom-report-reorder-popover-text">
                                                Reordenar Gráficos
                                            </span>
                                        </summary>
                                    )}

                                    {this.context.charts.map((chart, index) => (
                                        <ChartItem
                                            key={chart.id}
                                            chart={chart}
                                            editing={isReordering}
                                            selected={chartsListSelected.includes(index)}
                                            onClick={() => this.selectChart(index)}
                                            cliente={this.props.cliente}
                                            referencias={this.context.referencias.filter(
                                                r => r.grafico === chart.id
                                            )}
                                            resumos={this.context.resumos.filter(
                                                r => r.grafico === chart.id
                                            )}
                                            onEdit={() => {
                                                this.editChart(chart);
                                                this.getResource();
                                            }}
                                            onDelete={() =>
                                                this.context.confirmDelete(chart, "grafico")
                                            }
                                        />
                                    ))}
                                </>
                            ) : (
                                <div style={{ minHeight: "150px" }}>
                                    <p
                                        style={{
                                            textAlign: "center",
                                            marginTop: "30px",
                                            opacity: "0.8",
                                        }}
                                    >
                                        Sem gráficos cadastrados
                                    </p>
                                </div>
                            )}

                        </TabPanel>
                    </Tabs>

                    <div style={{ display: 'flex', justifyContent: tabIndex === 1 ? 'end' : 'space-between' }}>
                        <div style={{ display: tabIndex === 1 ? "none" : 'block' }} className="hdv-btn-group">
                            <button
                                onClick={this.buscarDadosRelatorio}
                                className="hdv-btn-forms hdv-btn-blue"
                                disabled={this.state.carregandoDados || charts?.length === 0 || !periodoValido}>
                                Gerar Relatório
                            </button>

                            <button
                                onClick={this.exportarPDF}
                                className="hdv-btn-forms hdv-btn-red"
                                disabled={!(this.state.relatorioGerado && this.state.exportCooldown === false)}>
                                Exportar PDF
                            </button>
                        </div>

                        <div className="hdv-btn-group">
                            <ButtonsForm
                                route="/relatorio"
                                edit={this.props.match.params.id ? true : false}
                                cooldown={this.state.cooldown || this.state.relatorioErro}
                                buttons={[
                                    {
                                        method: "post",
                                        button: <button onClick={this.saveAction} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                                    },
                                    {
                                        method: "patch",
                                        button: <button onClick={this.saveAction} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                                    },
                                ]}
                            />
                            <Link to="/relatorio-customizado">
                                <button disabled={this.state.cooldown} style={{ margin: "0px" }} className="hdv-btn-forms hdv-btn-yellow">Cancelar</button>
                            </Link>
                        </div>
                    </div>

                    {relatorioGerado ?
                        <>
                            {generatedCharts.map(chart => (
                                <GeneratedChart
                                    key={chart.id}
                                    {...chart}
                                />
                            ))}
                        </>
                        : null
                    }

                    {this.state.relatorioErro
                        ?
                        <p style={{ margin: '12px 0', textAlign: 'center', color: '#a33131', fontWeight: 'bold' }}>
                            Erro ao carregar relatório
                        </p>
                        :
                        null
                    }
                </div>
            </>
        )
    }
}

export default Form
